import { render, staticRenderFns } from "./knDict.vue?vue&type=template&id=6453a76c&scoped=true&"
import script from "./knDict.vue?vue&type=script&lang=js&"
export * from "./knDict.vue?vue&type=script&lang=js&"
import style0 from "./knDict.vue?vue&type=style&index=0&id=6453a76c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453a76c",
  null
  
)

export default component.exports